(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/common/constants.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/common/constants.js');
"use strict";


const PROLONG_SUBSCRIPTION = 'subscription';
const PROLONG_WAGERS_PARAMS = {
  prepCount: 'prep_count',
  prepDays: 'prep_days',
  prepId: 'prep_id',
  prolong: 'prolong'
};
setGlobal('svs.numbergames.prolong_game.common.constants', {
  PROLONG_SUBSCRIPTION,
  PROLONG_WAGERS_PARAMS
});

 })(window);